import * as React from "react";
import i18n from "../i18n";
import { getCurrentUser } from "../shared/getCurrentUser";
import { NavBarContainer } from "./NavBarContainer";
import { UserInfoAndLicencesSection } from "./UserInfoAndLicencesSection";

export function WebAppHome() {
  const userInfo = getCurrentUser();

  return (
    <NavBarContainer title="">
      <p>{i18n.t("home.welcome", { email: userInfo!.Email })}</p>
      <UserInfoAndLicencesSection userInfo={userInfo!} />
    </NavBarContainer>
  );
}
